module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Ticket_red-99387c94cdb1c2fb757e738db7242860.svg";